import $ from 'jquery';
import 'slick-carousel';
import 'jquery-lazy/jquery.lazy.min';
import AOS from 'aos';
import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap.js';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js';

introOnlyTitle();
lazyLoad();
fieldUpload();
accordion();
sliderInit();
sliderItemsInit();
sliderDetailsInit();
sliderWorks();
sliderImagesInit();
mobileNavTrigger();
initScrollMagic();
urlContainSucccess();

AOS.init({
    once: true,
});

ajaxForms();
listenForProductRequests();

window.recaptchaSuccess = false;

window.recaptcha_failure = function () {
    $('.section-contact form').html('<h4 class="form__success">There was an issue with the reCaptcha validation.</h4>');
};

window.recaptcha_callback = function (response) {
    if (response.score >= 0.5) {
        window.recaptchaSuccess = true;
    }
};

if (isMobile()) {
    navDropDownOnMobile();
}

function sliderInit() {
    const $slider = $('.slider .slider__slides');
    $slider.slick({
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    adaptiveHeight: true,
                },
            },
        ],
    });

    $('.slider .slick-dots button').on('click', function () {
        $slider.slick('slickGoTo', $(this).data('slide'));
    });
}

function sliderItemsInit() {
    $('.slider-news .slider__slides, .slider-testimonials .slider__slides').slick({
        dots: false,
        arrows: false,
        infinite: true,
        variableWidth: true,
        autoplay: true,
        responsive: [{
            breakpoint: 767,
            settings: {
                variableWidth: false,
            },
        }],
    }).on('afterChange', function () {
        $('.lazy').Lazy();
    });
}

function sliderWorks() {
    $('.slider-works .slider__slides').slick({
        dots: false,
        arrows: true,
        infinite: true,
        variableWidth: true,
        prevArrow: '<i class="fas fa-arrow-left"></i>',
        nextArrow: '<i class="fas fa-arrow-right"></i>',
    }).on('afterChange', function () {
        $('.lazy').Lazy();
    });
}

function sliderDetailsInit() {
    const $sliderDetails = $('.slider-details .slider__slides');
    $sliderDetails.slick({
        dots: false,
        arrows: false,
        infinite: true,
    }).on('afterChange', function (event, slick, currentSlide) {
        addActiveClass($('.section-details .section__nav li').eq(currentSlide));
        $('.lazy').Lazy();
    });

    $('.section-details .section__nav a').on('click', function (e) {
        const $this = $(this);
        $sliderDetails.slick('slickGoTo', $this.data('slide'));
        addActiveClass($this.parent());

        e.preventDefault();
    });
}

function addActiveClass($el) {
    $el.addClass('active')
        .siblings().removeClass('active');
}

function sliderImagesInit() {
    const $sliderImages = $('.slider-images .slider__slides');
    $sliderImages.slick({
        dots: false,
        arrows: false,
        infinite: true,
    }).on('afterChange', function (event, slick, currentSlide) {
        addActiveClass($('.slider-images .slider__thumbs li').eq(currentSlide));
        $('.lazy').Lazy();
    });

    $('.slider-images .slider__thumbs a').on('click', function (e) {
        const $this = $(this);
        $sliderImages.slick('slickGoTo', $this.data('slide'));
        addActiveClass($this.parent());

        e.preventDefault();
    });
}

function accordion() {
    $('.accordion__head').on('click', function (e) {
        const expandedClass = 'accordion__section--expanded';

        $(this).next().slideToggle()
            .parent()
            .toggleClass(expandedClass)
            .siblings('.accordion__section')
            .removeClass(expandedClass)
            .find('.accordion__body')
            .slideUp();
        e.preventDefault();
    });
}

function fieldUpload() {
    $('#field-file').change(function () {
        const $this = $(this);
        let text = '';
        let comma = ', ';
        const filesLength = $this[0].files.length;

        for (let i = 0; i < filesLength; i += 1) {
            if (i + 1 === filesLength) {
                comma = '';
            }
            text += $this[0].files[i].name + comma;
        }

        $this.parent().prev('label').text(text);
    });
}

function lazyLoad() {
    const $container = $('.lazy');
    if (!$container.length) {
        return false;
    }
    setTimeout(function () {
        $container.lazy({
            effect: 'fadeIn',
            effectTime: 100,
            threshold: 400,
            afterLoad: (element) => {
                element.addClass('is-loaded');
                AOS.refresh();
            },
            enableThrottle: false,
        });
    }, 200);

    // lazy load nav images
    $('.nav .menu-item-has-children').hover(function () {
        $(this).find('[data-src]').each(function (index, el) {
            if (el.tagName === 'IMG') {
                el.src = el.dataset.src;
            } else {
                el.style.backgroundImage = `url(${el.dataset.src})`;
            }
        });
    });
}

function isMobile() {
    return /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

function navDropDownOnMobile() {
    $('.nav .menu-item-has-children > a').one('click', false);
}

function mobileNavTrigger() {
    $('.nav-trigger').on('click', function (e) {
        $(this).add($('.header__inner')).toggleClass('active');
        e.preventDefault();
    });
}

function initScrollMagic() {
    // init controller
    const controller = new ScrollMagic.Controller();

    $('[data-parallax]').each((i, elem) => {
        const triggerElement = $(elem).closest('div')[0];
        let offset = -$(triggerElement).height();

        if (typeof $(elem).data('offset') !== 'undefined') {
            offset = $(elem).data('offset');
        }

        const duration = $(triggerElement).height() + $(window).outerHeight();

        // build scene
        new ScrollMagic.Scene({ triggerElement, duration, offset })
            .setTween(elem, { transform: `translateY(${elem.dataset.parallax})` })
            .addTo(controller);// .addIndicators();
    });
}

function ajaxForms() {
    const $form = $('.section-showrooms form, .footer form, .section-contact form');

    $form.each((index, element) => {
        const $currentForm = $(element);

        $currentForm.submit(event => ajaxFormSubmit(event, $currentForm));
    });
}

function ajaxFormSubmit(event, $form) {
    event.preventDefault();

    const $formActions = $form.find('.form__actions');
    const $submitButton = $form.find('input[type="submit"]');
    const formData = new FormData($form[0]);
    const formAction = $form.attr('action');
    const redirectUrl = $form.data('redirect');
    const saveEntryUrl = $form.data('save-entry');
    const entryType = $form.data('type');

    if (window.recaptchaSuccess === false) {
        alert('The Google reCAPTCHA verification failed. Please try reloading the page.'); // eslint-disable-line
        return;
    }

    $submitButton.attr('disabled', true);
    $formActions.append('<i class="fas fa-spinner fa-spin"></i>');
    $form.find('.form__controls--error').removeClass('form__controls--error');
    $form.find('.form__message').remove();
    $form.closest('.section-showrooms').find('.section-results').remove();
    $form.find('.form__error-top').remove();

    if (typeof window.document.documentMode === 'undefined') {
        if (formData.get('message[Subscribed]')) {
            formData.set('message[Subscribed]', 'Yes');
        } else {
            formData.set('message[Subscribed]', 'No');
        }
    }

    formData.append('type', entryType);
    formData.append('message[recaptchaSuccess]', window.recaptchaSuccess);

    $.ajax({
        url: formAction,
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        dataType: 'json',
        success(json) {
            $submitButton.attr('disabled', false);
            $formActions.find('.fa-spin').remove();

            if (typeof json.success !== 'boolean' && !formAction.includes('contact-form')) {
                $formActions.html('<strong>An unexpected error occurred. Please try again later.</strong>');
                return;
            }

            if (json.success === true) {
                if (formAction.includes('contact-form')) {
                    $.ajax({
                        url: saveEntryUrl,
                        type: 'POST',
                        data: formData,
                        processData: false,
                        contentType: false,
                        dataType: 'json',
                    });

                    if ($form.find('[name="message[Subscribed]"]').is(':checked')) {
                        $.ajax({
                            url: $form.data('mailchimp'),
                            type: 'POST',
                            dataType: 'json',
                            data: {
                                email: $form.find('[name="fromEmail"]').val(),
                                CRAFT_CSRF_TOKEN: window.csrfTokenValue,
                            },
                        });
                    }
                }

                $form.find('.form__errors').remove();

                if (redirectUrl) {
                    window.setTimeout(function () {
                        window.location = redirectUrl;
                    }, 1000);
                } else if (formAction.includes('dealers')) {
                    $form.closest('.shell').append($(json.markup));
                } else {
                    $form.html('<h4 class="form__success">Thank you for the submission!</h4>');
                }
            } else if (typeof json.errors === 'object') {
                let errors = {};
                if (formAction.includes('contact-form')) {
                    errors = Object.keys(json.errors);
                    errors.forEach(function (error, index) {
                        if (error.includes('message.')) {
                            errors[index] = `message[${error.replace('message.', '')}]`;
                        }
                    });
                } else {
                    errors = Object.values(json.errors);
                }

                errors.forEach(function (error) {
                    $form.find(`[name="${error}"]`).eq(0).closest('.form__controls').addClass('form__controls--error');
                });

                if (!formAction.includes('dealers')) {
                    $form.find('.form__body').prepend(`
                        <div class="form__error-top">
                            <i class="fas fa-exclamation-triangle"></i>

                            <strong>Please fix the errors outlined in red.</strong>
                        </div>
                        `);
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $form.find('.form__error-top').offset().top - 20,
                    }, 600);
                }
            } else if (typeof json.message === 'string' && json.message.length) {
                $form.find('.form__body').append(`<p class="form__message" style="color:red">${json.message}</p>`);
            }
        },
        error() {
            $form.html('An unexpected error occurred. Please try again later.');
        },
    });
}

function listenForProductRequests() {
    const $filters = $('.section__filter');
    const $categorySelect = $('#field-category');

    $categorySelect.change(function () {
        window.location = $(this).find(':selected').data('url');
    });

    $filters.change(function () {
        getNewProducts($filters, $categorySelect);
    });

    $('.section-listing').on('click', '.section__actions a', function (event) {
        event.preventDefault();

        getNewProducts($filters, $categorySelect, $('.products .product').length);
    });
}

function getNewProducts($filters, $categorySelect, offset = 0) {
    const $productsHolder = $('.section-listing .section__products');
    const $buildYourOwn = $('#field-build-your-own');
    const $new = $('#field-new');

    if (offset === 0) {
        $productsHolder.html('<div class="section__inner"><i class="fas fa-spinner fa-spin"></i></div>');
    } else {
        $productsHolder
            .find('.section__actions')
            .replaceWith('<div class="section__inner"><i class="fas fa-spinner fa-spin"></i></div>');
    }

    const data = {
        action: $filters.data('url'),
    };

    data[window.csrfTokenName] = window.csrfTokenValue;
    data.offset = offset;

    if ($categorySelect.length) {
        data.type = $categorySelect.data('type');

        data[`${data.type}Categories`] = $categorySelect.val();
    } else if ($filters.data('type')) {
        data.type = $filters.data('type');
    }

    $filters.find(':checked:not("#field-build-your-own")').each(function (index, el) {
        const $el = $(el);
        const filter = $el.closest('.accordion__section').data('filter');

        if (typeof data[filter] === 'undefined') {
            data[filter] = [];
        }
        data[filter].push($el.val());
    });

    data.buildYourOwn = $buildYourOwn.is(':checked') ? 1 : 0;
    data.new = $new.is(':checked') ? 1 : 0;

    $.ajax({
        type: 'POST',
        url: $filters.data('url'),
        data,
    }).then(function (response) {
        if (offset === 0) {
            $productsHolder.html(response);
        } else {
            const $newProducts = $('<div></div>').html(response).find('.product');
            const $loadMore = $('<div></div>').html(response).find('.section__actions');

            $productsHolder.find('> .section__inner').remove();
            $productsHolder.find('.products').append($newProducts);
            $productsHolder.append($loadMore);
        }
    });
}

function isIe() {
    return window.navigator.userAgent.indexOf('Trident/') > 0;
}

if (isIe()) {
    $('.js-image-fit').each((i, container) => {
        const $container = $(container);
        const $image = $container.find('img');
        const imageSource = $image.attr('src') || $image.data('src');

        $container.css('background-image', `url(${imageSource})`);
        $image.addClass('sr-only');
    });
}

function urlContainSucccess() {
    if (window.location.href.indexOf('?success') > -1 && $('.section-contact .form').length) {
        $('body, html').animate({
            scrollTop: $('.section-contact .form').offset().top,
        }, 1000);
    }
}

function introOnlyTitle() {
    if ($('.intro__content h2:only-child').length) {
        $('.intro').addClass('intro--single-title');
    }
}



// WEBPACK FOOTER //
// ./assets/js/main.js